import { TypographyP2 } from '@heidi/design-system/typography';
import { cn } from '@heidi/utils';

export const MicInputPreviewLabel = ({
  className,
  label,
}: {
  className?: string;
  label?: string;
}) => {
  if (!label) {
    return null;
  }
  return (
    <TypographyP2
      className={cn(
        'hidden max-w-20 truncate text-text-secondary @5xl:inline md:max-w-36',
        className
      )}
    >
      {label}
    </TypographyP2>
  );
};
